import {createActions} from 'client/framework';

const normalActions = [
  // Question actions
  'TOGGLE_OPTION'
];

export default createActions(null, normalActions);
